import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { fetchData, deleteData, activateData, updateData, SyncData, postData, DespatchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Tooltip } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import { useParams, useHistory } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';


function RouteWiseCollection() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [tripOptions, setTripOptions] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);

    const [tripDate, setTripDate] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchTripTypes();
    }, []);

    const fetchTripTypes = async () => {
        try {
            const response = await fetchData('CustomerOrderedItemAPI', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(trip => ({
                    value: trip.Id,
                    label: trip.Description
                }));
                setTripOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };


    const [filteredData, setFilteredData] = useState([]);
    const [Corderdate, setCorderdate] = useState("");
    const [orderTakenby, setOrdertakenby] = useState("");

    const [route, setroute] = useState("");

    const handleTripChange = async (selectedOption) => {
        setSelectedTrip(selectedOption);
        setData([]);

        try {
            const response = await fetchData('RouteWiseCollection', `/${companyId}/${selectedOption.value}`, token);

            if (response.responseCode === '1111') {
                const dataArray = response.response_data;

                dataArray.forEach(item => { });
                setData(dataArray);
                if (dataArray.length > 0) {

                } else {
                    console.error('Unexpected response code:', response.responseCode);
                }
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        }
    };
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };
    //search
    const searchfilteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );
    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Route Collection Summary</title></head><body>');
        printWindow.document.write('<h3 style="font-family: Times New Roman; font-size: 32px;">Route Collection Summary</h3>');
        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sl.No</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Invoice Date</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Customer Name</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Bill NO</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Bill Amount</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Opening Balance</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Total Amount</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Cash</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Gpay</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">NEFT/RTGS</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Cheque</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Credit</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Balance Amount</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Advance Amount</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        data.forEach((item, index) => {
            printWindow.document.write('<tr>');
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px; text-align: center;">${index + 1}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px; text-align: center;">${item.InvoiceDate ? new Date(item.InvoiceDate).toLocaleDateString('en-GB') : ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px;">${item.customername}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px;">${item.Billnumber}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px; text-align: right;">${typeof item.BillAmount === 'number' ? item.BillAmount.toFixed(2) : '00'}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px; text-align: right;">${typeof item.previousPending === 'number' ? item.previousPending.toFixed(2) : '00'}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px; text-align: right;">${typeof item.OutstandingAmount === 'number' ? item.OutstandingAmount.toFixed(2) : '00'}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px; text-align: right;">${typeof item.Cash === 'number' ? item.Cash.toFixed(2) : '00'}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px; text-align: right;">${typeof item.Gpay === 'number' ? item.gpay.toFixed(2) : '00'}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px; text-align: right;">${typeof item.neft === 'number' ? item.neft.toFixed(2) : '00'}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px; text-align: right;">${typeof item.Cheque === 'number' ? item.Cheque.toFixed(2) : '00'}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px; text-align: right;">${typeof item.credit === 'number' ? item.credit.toFixed(2) : '00'}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px; text-align: right;">${typeof item.BalanceAmount === 'number' ? item.BalanceAmount.toFixed(2) : '00'}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; padding: 8px; text-align: right;">${typeof item.Advanceamount === 'number' ? item.Advanceamount.toFixed(2) : '00'}</td>`);
            printWindow.document.write('</tr>');
        });

        printWindow.document.write('</tbody></table></body></html>');
        printWindow.document.close();
        printWindow.print();
    };



    //excel


    const handleExportExcel = () => {
        const workbook = XLSX.utils.book_new();
        const worksheetData = [
            ['Sl.No', 'Invoice Date', 'Customer Name', 'Bill NO', 'Bill Amount', 'Opening Balance', 'Total Amount', 'Cash', 'Gpay', 'NEFT/RTGS', 'Cheque', 'Credit', 'Balance Amount', 'Advance Amount']
        ];

        data.forEach((item, index) => {
            worksheetData.push([
                index + 1,
                item.InvoiceDate ? new Date(item.InvoiceDate).toLocaleDateString('en-GB') : '',
                item.customername,
                item.Billnumber,
                typeof item.BillAmount === 'number' ? item.BillAmount.toFixed(2) : '00',
                typeof item.previousPending === 'number' ? item.previousPending.toFixed(2) : '00',
                typeof item.OutstandingAmount === 'number' ? item.OutstandingAmount.toFixed(2) : '00',
                typeof item.Cash === 'number' ? item.Cash.toFixed(2) : '00',
                typeof item.gpay === 'number' ? item.Gpay.toFixed(2) : '00',
                typeof item.neft === 'number' ? item.neft.toFixed(2) : '00',
                typeof item.Cheque === 'number' ? item.Cheque.toFixed(2) : '00',
                typeof item.credit === 'number' ? item.credit.toFixed(2) : '00',
                typeof item.BalanceAmount === 'number' ? item.BalanceAmount.toFixed(2) : '00',
                typeof item.Advanceamount === 'number' ? item.Advanceamount.toFixed(2) : '00'
            ]);
        });

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Route Collection Summary');
        XLSX.writeFile(workbook, 'Route_Collection_Summary.xlsx');
    };


    const handleRefreshClick = () => {
        // setToDate(getCurrentDate());
        // fetchData();
        window.location.reload();
    };
    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([

        'SL No',
        'Sales Executive',
        'Expense Date ',
        'Expense Type',
        'Expense Remark',
        'Odometer',
        'Amount',
        ''

    ]);
    // Process and paginate the data
    const processedData = searchfilteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };
    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };

    return (
        <div className="w-full  mx-auto" style={{ width: '97%', marginTop: '10px' }}>

            <h6
                className="uppercase tracking-wide text-black flex-grow linkcolor"
                style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                COLLECTION SUMMARY(ROUTEWISE)</h6>
            <div className="flex justify-end">
                <div style={{ marginRight: '10px', marginTop: '-10px', }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '300px' : '200px',
                            height: '40px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginTop: '-10px'
                        }}
                    />
                </div>
                <div className="w-1/4 mr-2" style={{ marginTop: '-10px', marginLeft: '2px' }}>
                    <Select
                        value={selectedTrip}
                        onChange={handleTripChange}
                        options={tripOptions}
                        placeholder="Select Trip"
                        isSearchable
                        styles={{
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1301, // Ensure dropdown appears above the sticky header
                            }),
                        }}
                    />
                </div>

                <Button
                    style={{
                        backgroundColor: '#C9E9D2',
                        color: 'black',
                        height: '36px',
                        marginTop: '-10px',
                        marginLeft: '5px'

                    }}
                    onClick={handleRefreshClick}
                    className="linkcolor"
                >
                    <span>Refresh</span>
                </Button>
                <Button
                    style={{
                        backgroundColor: '#F8E8EE',
                        color: 'black',
                        height: '36px',
                        marginTop: '-10px',
                        marginLeft: '5px'

                    }}
                    onClick={handleExportExcel}
                    className="linkcolor"
                >
                    <span>Excel</span>
                </Button>
                <Button
                    style={{
                        backgroundColor: '#E8F3D6',
                        color: 'black',
                        height: '36px',
                        marginTop: '-10px',
                        marginLeft: '5px'

                    }}
                    onClick={handlePrint}
                    className="linkcolor"
                >
                    <span>Print</span>
                </Button>

            </div>
            <div className='w-full mb-5 flex' style={{ maxHeight: '520px', overflowY: 'auto', marginTop: '5px' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{
                            backgroundColor: '#795757', width: '1500px', position: 'sticky', // Makes the header sticky
                            top: 0,             // Locks it to the top
                            zIndex: 1,
                        }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '30px' }}>Sl.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '120px' }}>Invoice Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '150px' }}>Customer Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '90px' }}>Bill No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '100px' }}>Bill Amount</TableCell>
                                {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '150px' }}>Opening Balance</TableCell> */}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '150px' }}>Opening Balance</TableCell>

                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '120px' }}>Total Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'right', width: '100px' }}>Cash</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'right', width: '100px' }}>Gpay</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'right', width: '90px' }}>NEFT/RTGS</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'right', width: '90px' }}>Cheque</TableCell>
                                {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'right', width: '90px' }}>Credit</TableCell>*/}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '150px' }}>Balance Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '150px' }}>Advance Amount</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#F5F5F7' }}>
                            {processedData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    className={item.customername === 'Total' ? 'highlighted-row' : ''}
                                    sx={{
                                        padding: '5px',
                                        height: '42px',
                                        // backgroundColor: item.customername === 'Total' ? '#D8B4F8' : 'transparent',
                                        backgroundColor: item.customername === 'Total' ? '#C7B7A3' : 'transparent',

                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '13px', width: '50px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '13px', width: '100px' }}>{item.InvoiceDate ? new Date(item.InvoiceDate).toLocaleDateString('en-GB') : ''}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '13px', width: '150px' }}>{item.customername}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '13px', width: '100px' }}>{item.Billnumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '13px', width: '100px' }}>{typeof item.BillAmount === 'number' ? item.BillAmount.toFixed(2) : '00'}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '13px', width: '100px' }}>{typeof item.previousPending === 'number' ? item.previousPending.toFixed(2) : '00'}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '13px', width: '100px' }}>{typeof item.OutstandingAmount === 'number' ? item.OutstandingAmount.toFixed(2) : '00'}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '13px', width: '100px' }}>{typeof item.Cash === 'number' ? item.Cash.toFixed(2) : '00'}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '13px', width: '100px' }}>{typeof item.Gpay === 'number' ? item.Gpay.toFixed(2) : '00'}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '13px', width: '100px' }}>{typeof item.neft === 'number' ? item.neft.toFixed(2) : '00'}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '13px', width: '90px' }}>{typeof item.Cheque === 'number' ? item.Cheque.toFixed(2) : '00'}</TableCell>
                                    {/*<TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '13px', width: '90px' }}>{typeof item.Credit === 'number' ? item.Credit.toFixed(2) : '00'}</TableCell>*/}
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '13px', width: '150px' }}> {typeof item.BalanceAmount === 'number' ? item.BalanceAmount.toFixed(2) : '00'}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'Black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '13px', width: '150px' }}> {typeof item.Advanceamount === 'number' ? item.Advanceamount.toFixed(2) : '00'}</TableCell>



                                </TableRow>
                            ))}
                        </TableBody>
                        <TableFooter style={{ padding: '5px' }}>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                    count={searchfilteredData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </TableContainer>
            </div>


        </div>
    );
}

export default RouteWiseCollection;